import { useEffect } from 'react'
import type { BranchState } from '../lib/branchState'
import { useBranchLive } from '../lib/useBranch'
import { useStaffText } from '../ui/StaffText'

/**
 * The branch's desks as the floor sees them right now.
 *
 * The live channel follows one branch per browser, the one the top bar chose; it
 * is pointed at this one while the section is open, which is the branch the
 * administrator chose in the same top bar.
 */
export function useLiveBranch(branchId: string): BranchState | null {
  const { lang } = useStaffText()
  const live = useBranchLive('administration', { lang })
  const { chooseBranch } = live
  const following = live.branch?.id
  useEffect(() => {
    if (following && following !== branchId) chooseBranch(branchId)
  }, [following, branchId, chooseBranch])
  return live.state && live.state.branchId === branchId ? live.state : null
}
